import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import createLoader from './createLoader';

var loadFacebookScript = function loadFacebookScript(d, s, id, locale) {
  var fjs = d.getElementsByTagName(s)[0];

  if (d.getElementById(id)) {
    return;
  }

  var js = d.createElement(s);
  js.id = id;
  js.src = "//connect.facebook.net/".concat(locale, "/sdk.js");
  fjs.parentNode.insertBefore(js, fjs);
};

var loadFacebook = createLoader(function (opts) {
  return new Promise(function (resolve) {
    var options = _objectSpread({
      appId: null,
      locale: 'EN_US',
      autoLogAppEvents: true,
      cookie: true,
      state: true,
      version: 'v6.0'
    }, opts);

    window.fbAsyncInit = function () {
      window.FB.init(_objectSpread({}, options));
      window.FB.AppEvents.logPageView();
      resolve(window.FB);
    };

    loadFacebookScript(document, 'script', 'facebook-jssdk', options.locale);
  });
}, function () {
  return typeof window.FB !== 'undefined' ? window.FB : null;
});
export default loadFacebook;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/services/es/loadFacebook.js
// module id = null
// module chunks = 